var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconAttendance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E1EAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F7F9FD",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.4102 25.4283L23.7479 27.839C24.8479 24.6791 25.7641 23.2926 27.8388 21.4104",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3533 23.1123C22.5322 22.451 22.3139 21.7223 21.5321 21.2016C19.9023 20.1161 17.9448 19.4834 15.8397 19.4834C13.7345 19.4834 11.7771 20.1161 10.1472 21.2016C8.33011 22.4119 9.5571 24.7461 11.7403 24.7461H19.0047C19.1204 24.3366 19.3424 23.9512 19.6699 23.6336C20.4041 22.9216 21.463 22.7504 22.3533 23.1123Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1513 24.7461H11.7403C9.5571 24.7461 8.33011 22.4119 10.1472 21.2016C11.7771 20.1161 13.7345 19.4834 15.8397 19.4834C17.9448 19.4834 19.9023 20.1161 21.5321 21.2016C21.9915 21.5075 22.2563 21.8853 22.3603 22.279",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8422 16.6973C18.2197 16.6973 19.557 15.36 19.557 12.9825C19.557 10.605 18.2197 9.26761 15.8422 9.26761C13.4646 9.26761 12.1273 10.605 12.1273 12.9825C12.1273 15.36 13.4646 16.6973 15.8422 16.6973Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8422 16.6973C18.2197 16.6973 19.557 15.36 19.557 12.9825C19.557 10.605 18.2197 9.26761 15.8422 9.26761C13.4646 9.26761 12.1273 10.605 12.1273 12.9825C12.1273 15.36 13.4646 16.6973 15.8422 16.6973Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconAttendance);
export default __webpack_public_path__ + "static/media/MetricIconAttendance.37831057ef4f74b2b262ca41854fde7d.svg";
export { ForwardRef as ReactComponent };